import { InvestmentsScheduledTransferKeyEnum } from './investments-financial-enum'

export const DEPOSIT_TYPE_LABEL = {
  punctual: 'guardar pontualmente',
  [InvestmentsScheduledTransferKeyEnum.ONE_SHOT]: 'guardar agendado',
  [InvestmentsScheduledTransferKeyEnum.RECURRENT]: 'guardar automaticamente',
  [InvestmentsScheduledTransferKeyEnum.AUTOMATIC]: 'guardar por recebimentos'
} as const

export type DepositTypeLabel = (typeof DEPOSIT_TYPE_LABEL)[keyof typeof DEPOSIT_TYPE_LABEL]

export const FEEDBACK_STATUS_LABEL = {
  loading: 'processando',
  slow: 'demorando',
  success: 'sucesso',
  error: 'erro'
} as const

export type FeedbackStatusLabel = (typeof FEEDBACK_STATUS_LABEL)[keyof typeof FEEDBACK_STATUS_LABEL]
